'use client'
import Footer from "@/components/common/Footer/Footer";
import Header from "@/components/common/Header/Student/Header";
import useInitialDispatch from "@/hook/useInitialDispatch";
import { FaArrowUp } from "react-icons/fa";
import { useEffect } from 'react';

export default function HomeLayout({ children }) {
  // useInitialDispatch();
  return (
    <div className="site">
      <Header />
      <main className="flex-1 flex flex-col">{children}</main>
      <Footer />
    </div>
  );
}
